import { render, staticRenderFns } from "./work_learner_data.vue?vue&type=template&id=513ecc6c&scoped=true"
import script from "./work_learner_data.vue?vue&type=script&lang=js"
export * from "./work_learner_data.vue?vue&type=script&lang=js"
import style0 from "./work_learner_data.vue?vue&type=style&index=0&id=513ecc6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513ecc6c",
  null
  
)

export default component.exports